<template>
  <div
    class="eventComp_mode_27 eventComp_mode_container"
    :class="[
      notJumpDetailPage.includes(sportCompetitionType)
        ? 'notJumpDetailPageClass'
        : '',
    ]"
    v-show="currThemeObj"
  >
    <div class="tableScrollArea" ref="tableParentDom">
      <div class="group_box" v-for="(group, index) in groupTable" :key="index">
        <span
          class="groupBox_title"
          v-text="_valPerFormatHandler(group.gruopName)"
        ></span>
        <multiLevelFold_table
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :tableMode="tableMode"
          :parentWidthPx="parentWidthPx"
          :isScrollFlag="isScrollFlag"
          :variableColWidthVw="variableColWidthVw"
          :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
          :defaultWidthVwNum="group.defaultWidthVwNum"
          :tableColumnData="group.tableColumnData"
          :tableData="group.tableData"
          @toParentEvent="toParentEventHandler"
          :sportCompetitionType="sportCompetitionType"
          v-show="group.tableData && group.tableData.length > 0"
        ></multiLevelFold_table>
      </div>
    </div>
  </div>
</template>

<script>
// 适用： 团体多场比赛，以代表团为单位展示，多人人名拼接 【 汤尤杯 】表格
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_27',
  components: {
    multiLevelFold_table,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    competitorType: {
      type: String, //竞赛者的类型 A || D || T,
      default: '',
    },
    sportCompetitionType: {
      type: String, //赛事类型
      default: '',
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_27 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isScrollBottom: false,
      tableMode: 'eventComp_mode_27',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: null,
      tableCellDefaultWidthVw: 6.94,
      defaultWidthVwNum: null,
      tableColumnData: [],
      groupTable: null,
    }
  },
  beforeCreate() {},
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.onResizeEvent()
        // this.computedModeData({})
        console.debug('groupTable:', this.datas)
        const keyArr = ['home', 'away']

        let groupTable = []
        this.datas.subUnit.forEach((matchItem) => {
          let table_headArr = [
            {
              name: '运动员',
              map_key_arr: ['team_logo', 'playerListString'],
            },
            {
              name: '比分',
              map_key_arr: ['score'],
            },
          ]
          const origin_table_headArr =
            matchItem.home && matchItem.home.score_detail
              ? matchItem.home.score_detail
              : []
          origin_table_headArr.forEach((column) => {
            table_headArr.push({
              name: column.periodName,
              map_key_arr: [column.periodCode],
            })
          })

          let tabelData = {
            data: keyArr.map((key) => {
              let rowData = {}
              rowData.score = matchItem[key].score
              console.debug('matchItem[key]', key, matchItem[key])
              matchItem[key].score_detail.forEach((scoreItem) => {
                rowData[scoreItem.periodCode] = scoreItem.periodScore
              })
              if (matchItem[key].players && matchItem[key].players.length > 0) {
                rowData.team_name = matchItem[key].players[0].team_name
                  ? matchItem[key].players[0].team_name
                  : ''
                rowData.team_logo = matchItem[key].players[0].team_logo
                  ? matchItem[key].players[0].team_logo
                  : ''
                rowData.players = matchItem[key].players
              } else {
                rowData.team_name = ''
                rowData.team_logo = ''
              }
              return rowData
            }),
            table_head: table_headArr,
          }
          groupTable.push(tabelData)
        })
        console.debug('groupTable:', groupTable)
        this.groupTable = groupTable.map((group, gIndex) => {
          return this.computedModeData(group, gIndex + 1)
        })
      })
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    toParentEventHandler(data) {
      console.debug(data)
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedModeData(data, ind) {
      console.debug('computedModeData:', data)
      if (data && data.data) {
        const table_headArr = data.table_head

        // 表头
        const headColumns = []
        table_headArr.forEach((colums, colIndex) => {
          if (colums && colums.map_key_arr.length < 2) {
            headColumns.push({
              colKey: colums.map_key_arr[0] ? colums.map_key_arr[0] : '',
              colTitle: colums.name ? colums.name : '',
            })
          }
        })

        const otherColumns = headColumns

        let tableColumnData = []
        if (this.tableColumnData.length == 0) {
          //   const customColumn = {
          //     prop: 'playerName-playerLogo-playerGender-teamLogo-teamName', //fristColumnPropArr.join('-'),
          //     label: '运动员',
          //     // widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
          //     className: 'columnPlayerGroupClass', //单独定制的头部样式class
          //     // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          //   }
          const customColumn = {
            prop: 'teamLogo-playerListString', //fristColumnPropArr.join('-'),
            label: '运动员',
            // widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
            className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
            // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          }

          for (let i = 0; i < otherColumns.length; i++) {
            if (i == 0) {
              tableColumnData.push(customColumn)
            }
            const item = otherColumns[i]
            tableColumnData.push({
              prop: item.colKey,
              label: item.colTitle,
              // widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
              //   ? this.tableCellDefaultWidthVw / 2
              //   : this.tableCellDefaultWidthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
              // className: ['arrowIcon', 'isExpand'].includes(item.colKey)
              //   ? 'expandTdClassName'
              //   : '', //单独定制的头部样式class
              widthVw: this.tableCellDefaultWidthVw,
              className: '',
              selected: '',
            })
          }
        }

        return {
          gruopName: `第${ind}场`,
          tableData: data.data.map((rowData) => {
            return rowData
          }),
          tableColumnData,
          defaultWidthVwNum: tableColumnData.length - 1, //减去【teamLogo-teamName】
        }
        // this.$refs.tableParentDom.scrollTo(0, 0)
      } else {
        console.debug('暂无数据')
        this.notDataHandler()
      }
    },
    notDataHandler() {
      return {
        gruopName: '',
        tableData: [],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  &.notJumpDetailPageClass {
    *:not(.publishBtn) {
      cursor: default !important;
    }
  }
  .tableScrollArea {
    position: relative;
    width: 100%;
    .group_box {
      width: 100%;
      height: auto;
      padding-bottom: 1.388vw;
      .groupBox_title {
        display: block;
        height: 2.788vw;
        line-height: 2.788vw;
        font-size: 1.11vw;
        color: var(--mixtmt_greyColor3);
        font-weight: bold;
      }
    }
  }
}
</style>
